/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Unified App Features API
 * API for Coins, Rewards, Goals, Referrals, Streaks, and Ratings.
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GenerateReferralCodeParams,
  GetUserPositiveLoginDetailsByUserIdParams,
  GetUserReferalByReferralCodeParams,
  GetUserReferralByUserIdParams,
  GetUserReferralByUserReferralId200,
  GetUserReferralByUserReferralIdParams,
  GetUserReferralMappingByUserReferralMappingIdParams,
  RemindReferralByUserReferralMappingIdParams,
  SaveUserReferralDetailsParams,
  SaveUserReferralMappingParams,
  UpdateTransactionByUserIdParams,
  UpdateTransactionByUserReferralMappingIdParams,
  UserPositiveLoginDetailsDto,
  UserReferralDetailsDto,
  UserReferralDto,
  UserReferralMappingDto,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Generate referral code
 */
export const generateReferralCode = (
  params: GenerateReferralCodeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralDto>(
    {
      url: `/api/referral/userReferral/generate`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getGenerateReferralCodeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReferralCode>>,
    TError,
    { params: GenerateReferralCodeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateReferralCode>>,
  TError,
  { params: GenerateReferralCodeParams },
  TContext
> => {
  const mutationKey = ["generateReferralCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateReferralCode>>,
    { params: GenerateReferralCodeParams }
  > = (props) => {
    const { params } = props ?? {};

    return generateReferralCode(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateReferralCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateReferralCode>>
>;

export type GenerateReferralCodeMutationError = unknown;

/**
 * @summary Generate referral code
 */
export const useGenerateReferralCode = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateReferralCode>>,
      TError,
      { params: GenerateReferralCodeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateReferralCode>>,
  TError,
  { params: GenerateReferralCodeParams },
  TContext
> => {
  const mutationOptions = getGenerateReferralCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get user referral by User ID
 */
export const getUserReferralByUserId = (
  params: GetUserReferralByUserIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralDto>(
    { url: `/api/referral/userReferral/userId`, method: "GET", params, signal },
    options,
  );
};

export const getGetUserReferralByUserIdQueryKey = (
  params?: GetUserReferralByUserIdParams,
) => {
  return [
    `/api/referral/userReferral/userId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserReferralByUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserReferralByUserId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserReferralByUserIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserReferralByUserId>>
  > = ({ signal }) => getUserReferralByUserId(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserReferralByUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserReferralByUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserReferralByUserId>>
>;
export type GetUserReferralByUserIdQueryError = unknown;

export function useGetUserReferralByUserId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferralByUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserReferralByUserId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferralByUserId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferralByUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserReferralByUserId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferralByUserId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user referral by User ID
 */

export function useGetUserReferralByUserId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserReferralByUserIdQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user referral by Referral Code
 */
export const getUserReferalByReferralCode = (
  params: GetUserReferalByReferralCodeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralDto>(
    {
      url: `/api/referral/userReferral/referralcode`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetUserReferalByReferralCodeQueryKey = (
  params?: GetUserReferalByReferralCodeParams,
) => {
  return [
    `/api/referral/userReferral/referralcode`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserReferalByReferralCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
  TError = unknown,
>(
  params: GetUserReferalByReferralCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserReferalByReferralCodeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserReferalByReferralCode>>
  > = ({ signal }) =>
    getUserReferalByReferralCode(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserReferalByReferralCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserReferalByReferralCode>>
>;
export type GetUserReferalByReferralCodeQueryError = unknown;

export function useGetUserReferalByReferralCode<
  TData = Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
  TError = unknown,
>(
  params: GetUserReferalByReferralCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
          TError,
          Awaited<ReturnType<typeof getUserReferalByReferralCode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferalByReferralCode<
  TData = Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
  TError = unknown,
>(
  params: GetUserReferalByReferralCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
          TError,
          Awaited<ReturnType<typeof getUserReferalByReferralCode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferalByReferralCode<
  TData = Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
  TError = unknown,
>(
  params: GetUserReferalByReferralCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user referral by Referral Code
 */

export function useGetUserReferalByReferralCode<
  TData = Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
  TError = unknown,
>(
  params: GetUserReferalByReferralCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferalByReferralCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserReferalByReferralCodeQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save user referral details
 */
export const saveUserReferralDetails = (
  params: SaveUserReferralDetailsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralDetailsDto>(
    {
      url: `/api/referral/userReferralDetails`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getSaveUserReferralDetailsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveUserReferralDetails>>,
    TError,
    { params: SaveUserReferralDetailsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveUserReferralDetails>>,
  TError,
  { params: SaveUserReferralDetailsParams },
  TContext
> => {
  const mutationKey = ["saveUserReferralDetails"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveUserReferralDetails>>,
    { params: SaveUserReferralDetailsParams }
  > = (props) => {
    const { params } = props ?? {};

    return saveUserReferralDetails(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveUserReferralDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveUserReferralDetails>>
>;

export type SaveUserReferralDetailsMutationError = unknown;

/**
 * @summary Save user referral details
 */
export const useSaveUserReferralDetails = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveUserReferralDetails>>,
      TError,
      { params: SaveUserReferralDetailsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveUserReferralDetails>>,
  TError,
  { params: SaveUserReferralDetailsParams },
  TContext
> => {
  const mutationOptions = getSaveUserReferralDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save user referral mapping
 */
export const saveUserReferralMapping = (
  params: SaveUserReferralMappingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralMappingDto>(
    {
      url: `/api/referral/userReferralMapping`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getSaveUserReferralMappingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveUserReferralMapping>>,
    TError,
    { params: SaveUserReferralMappingParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveUserReferralMapping>>,
  TError,
  { params: SaveUserReferralMappingParams },
  TContext
> => {
  const mutationKey = ["saveUserReferralMapping"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveUserReferralMapping>>,
    { params: SaveUserReferralMappingParams }
  > = (props) => {
    const { params } = props ?? {};

    return saveUserReferralMapping(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveUserReferralMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveUserReferralMapping>>
>;

export type SaveUserReferralMappingMutationError = unknown;

/**
 * @summary Save user referral mapping
 */
export const useSaveUserReferralMapping = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveUserReferralMapping>>,
      TError,
      { params: SaveUserReferralMappingParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveUserReferralMapping>>,
  TError,
  { params: SaveUserReferralMappingParams },
  TContext
> => {
  const mutationOptions = getSaveUserReferralMappingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get user referral mapping by User Referral ID
 */
export const getUserReferralByUserReferralId = (
  params: GetUserReferralByUserReferralIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetUserReferralByUserReferralId200>(
    {
      url: `/api/referral/userReferralMapping/userReferralId`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetUserReferralByUserReferralIdQueryKey = (
  params?: GetUserReferralByUserReferralIdParams,
) => {
  return [
    `/api/referral/userReferralMapping/userReferralId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserReferralByUserReferralIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserReferralIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserReferralByUserReferralIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserReferralByUserReferralId>>
  > = ({ signal }) =>
    getUserReferralByUserReferralId(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserReferralByUserReferralIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserReferralByUserReferralId>>
>;
export type GetUserReferralByUserReferralIdQueryError = unknown;

export function useGetUserReferralByUserReferralId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserReferralIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
          TError,
          Awaited<ReturnType<typeof getUserReferralByUserReferralId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferralByUserReferralId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserReferralIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
          TError,
          Awaited<ReturnType<typeof getUserReferralByUserReferralId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferralByUserReferralId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserReferralIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user referral mapping by User Referral ID
 */

export function useGetUserReferralByUserReferralId<
  TData = Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
  TError = unknown,
>(
  params: GetUserReferralByUserReferralIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserReferralByUserReferralId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserReferralByUserReferralIdQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user referral mapping by ID
 */
export const getUserReferralMappingByUserReferralMappingId = (
  params: GetUserReferralMappingByUserReferralMappingIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralMappingDto>(
    {
      url: `/api/referral/userReferralMapping/userReferralMappingId`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetUserReferralMappingByUserReferralMappingIdQueryKey = (
  params?: GetUserReferralMappingByUserReferralMappingIdParams,
) => {
  return [
    `/api/referral/userReferralMapping/userReferralMappingId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserReferralMappingByUserReferralMappingIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
  >,
  TError = unknown,
>(
  params: GetUserReferralMappingByUserReferralMappingIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserReferralMappingByUserReferralMappingIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserReferralMappingByUserReferralMappingId>>
  > = ({ signal }) =>
    getUserReferralMappingByUserReferralMappingId(
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserReferralMappingByUserReferralMappingId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserReferralMappingByUserReferralMappingIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserReferralMappingByUserReferralMappingId>>
  >;
export type GetUserReferralMappingByUserReferralMappingIdQueryError = unknown;

export function useGetUserReferralMappingByUserReferralMappingId<
  TData = Awaited<
    ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
  >,
  TError = unknown,
>(
  params: GetUserReferralMappingByUserReferralMappingIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferralMappingByUserReferralMappingId<
  TData = Awaited<
    ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
  >,
  TError = unknown,
>(
  params: GetUserReferralMappingByUserReferralMappingIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReferralMappingByUserReferralMappingId<
  TData = Awaited<
    ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
  >,
  TError = unknown,
>(
  params: GetUserReferralMappingByUserReferralMappingIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user referral mapping by ID
 */

export function useGetUserReferralMappingByUserReferralMappingId<
  TData = Awaited<
    ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
  >,
  TError = unknown,
>(
  params: GetUserReferralMappingByUserReferralMappingIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReferralMappingByUserReferralMappingId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetUserReferralMappingByUserReferralMappingIdQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Remind referral
 */
export const remindReferralByUserReferralMappingId = (
  params: RemindReferralByUserReferralMappingIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralMappingDto>(
    {
      url: `/api/referral/userReferralMapping/remind/userReferralMappingId`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getRemindReferralByUserReferralMappingIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof remindReferralByUserReferralMappingId>>,
    TError,
    { params: RemindReferralByUserReferralMappingIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof remindReferralByUserReferralMappingId>>,
  TError,
  { params: RemindReferralByUserReferralMappingIdParams },
  TContext
> => {
  const mutationKey = ["remindReferralByUserReferralMappingId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof remindReferralByUserReferralMappingId>>,
    { params: RemindReferralByUserReferralMappingIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return remindReferralByUserReferralMappingId(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemindReferralByUserReferralMappingIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof remindReferralByUserReferralMappingId>>
>;

export type RemindReferralByUserReferralMappingIdMutationError = unknown;

/**
 * @summary Remind referral
 */
export const useRemindReferralByUserReferralMappingId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof remindReferralByUserReferralMappingId>>,
      TError,
      { params: RemindReferralByUserReferralMappingIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof remindReferralByUserReferralMappingId>>,
  TError,
  { params: RemindReferralByUserReferralMappingIdParams },
  TContext
> => {
  const mutationOptions =
    getRemindReferralByUserReferralMappingIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update transaction by User Referral Mapping ID
 */
export const updateTransactionByUserReferralMappingId = (
  params: UpdateTransactionByUserReferralMappingIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralMappingDto>(
    {
      url: `/api/referral/userReferralMapping/transaction/userReferralMappingId`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getUpdateTransactionByUserReferralMappingIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTransactionByUserReferralMappingId>>,
    TError,
    { params: UpdateTransactionByUserReferralMappingIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTransactionByUserReferralMappingId>>,
  TError,
  { params: UpdateTransactionByUserReferralMappingIdParams },
  TContext
> => {
  const mutationKey = ["updateTransactionByUserReferralMappingId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTransactionByUserReferralMappingId>>,
    { params: UpdateTransactionByUserReferralMappingIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return updateTransactionByUserReferralMappingId(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTransactionByUserReferralMappingIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTransactionByUserReferralMappingId>>
  >;

export type UpdateTransactionByUserReferralMappingIdMutationError = unknown;

/**
 * @summary Update transaction by User Referral Mapping ID
 */
export const useUpdateTransactionByUserReferralMappingId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTransactionByUserReferralMappingId>>,
      TError,
      { params: UpdateTransactionByUserReferralMappingIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTransactionByUserReferralMappingId>>,
  TError,
  { params: UpdateTransactionByUserReferralMappingIdParams },
  TContext
> => {
  const mutationOptions =
    getUpdateTransactionByUserReferralMappingIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update transaction by User ID
 */
export const updateTransactionByUserId = (
  params: UpdateTransactionByUserIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserReferralMappingDto>(
    {
      url: `/api/referral/userReferralMapping/transaction/userId`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getUpdateTransactionByUserIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTransactionByUserId>>,
    TError,
    { params: UpdateTransactionByUserIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTransactionByUserId>>,
  TError,
  { params: UpdateTransactionByUserIdParams },
  TContext
> => {
  const mutationKey = ["updateTransactionByUserId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTransactionByUserId>>,
    { params: UpdateTransactionByUserIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return updateTransactionByUserId(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTransactionByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTransactionByUserId>>
>;

export type UpdateTransactionByUserIdMutationError = unknown;

/**
 * @summary Update transaction by User ID
 */
export const useUpdateTransactionByUserId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTransactionByUserId>>,
      TError,
      { params: UpdateTransactionByUserIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTransactionByUserId>>,
  TError,
  { params: UpdateTransactionByUserIdParams },
  TContext
> => {
  const mutationOptions = getUpdateTransactionByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get user positive login details by User ID
 */
export const getUserPositiveLoginDetailsByUserId = (
  params: GetUserPositiveLoginDetailsByUserIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserPositiveLoginDetailsDto>(
    {
      url: `/api/referral/userReferral/positiveLogin/userId`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetUserPositiveLoginDetailsByUserIdQueryKey = (
  params?: GetUserPositiveLoginDetailsByUserIdParams,
) => {
  return [
    `/api/referral/userReferral/positiveLogin/userId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserPositiveLoginDetailsByUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
  TError = unknown,
>(
  params: GetUserPositiveLoginDetailsByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserPositiveLoginDetailsByUserIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>
  > = ({ signal }) =>
    getUserPositiveLoginDetailsByUserId(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserPositiveLoginDetailsByUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>
>;
export type GetUserPositiveLoginDetailsByUserIdQueryError = unknown;

export function useGetUserPositiveLoginDetailsByUserId<
  TData = Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
  TError = unknown,
>(
  params: GetUserPositiveLoginDetailsByUserIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPositiveLoginDetailsByUserId<
  TData = Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
  TError = unknown,
>(
  params: GetUserPositiveLoginDetailsByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserPositiveLoginDetailsByUserId<
  TData = Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
  TError = unknown,
>(
  params: GetUserPositiveLoginDetailsByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user positive login details by User ID
 */

export function useGetUserPositiveLoginDetailsByUserId<
  TData = Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
  TError = unknown,
>(
  params: GetUserPositiveLoginDetailsByUserIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPositiveLoginDetailsByUserId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserPositiveLoginDetailsByUserIdQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
